import React from 'react';
import './Brochure.css';

const Brochure = () => {
  const handlePreview = () => {
    // In a real app, this would open the PDF in a new tab
    window.open('/brochure.pdf', '_blank');
  };

  const handleDownload = () => {
    // In a real app, this would trigger the PDF download
    window.open('/brochure.pdf', '_blank'); // For demo purposes
  };

  return (
    <div id="brochure" className="brochure-page">
      <div className="container">
        <h1 className="page-title">FEST BROCHURE</h1>

        <div className="brochure-actions">
          <button onClick={handlePreview} className="btn btn-primary fire-glow">Preview Brochure</button>
          <button onClick={handleDownload} className="btn btn-secondary">Download Brochure</button>
        </div>


      </div>
    </div>
  );
};

export default Brochure;